enum Product {
  CheckIn = 'check-in',
  LeadCapture = 'lead-capture',
  Legacy = 'legacy',
}

export default Product;
